import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { basketStatusesLocale } from '@epicuro-next/constants/features/localization';
import { BasketManagerTableComponent } from '@epicuro-next/platform/dynamic-components';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { BasketStatus } from 'graphql-api/baskets-api-interfaces';

@Component({
  selector: 'epc-basket-status-badge',
  templateUrl: './basket-status-badge.component.html',
  styleUrls: ['./basket-status-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
@DynamicComponentRegister(BasketManagerTableComponent.StatusBadge)
export class BasketStatusBadgeComponent {
  @Input() public value: BasketStatus = BasketStatus.New;

  public get statusClass() {
    switch (this.value) {
      case BasketStatus.Acknowledged:
      case BasketStatus.New:
        return 'basket-status-badge-new';

      case BasketStatus.Processed:
      case BasketStatus.PaymentSuccess:
        return 'basket-status-badge-success';

      case BasketStatus.Processing:
      case BasketStatus.Submitted:
      case BasketStatus.PaymentInitiated:
      case BasketStatus.Pending:
        return 'basket-status-badge-pending';
      case BasketStatus.Rejected:
        return 'basket-status-badge-rejected';
      case BasketStatus.Failed:
      case BasketStatus.PaymentFailed:
        return 'basket-status-badge-failed';
      default:
        break;
    }
  }

  public translations = basketStatusesLocale;
}
